import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from "@angular/common";

@Pipe({ name: 'dateFormatter', pure: true })
export class DateFormatterPipe extends DatePipe implements PipeTransform {

  transform(value: any, pattern: string = "dateFormatter"): string | null {
    pattern = 'y-MM-dd';
    let result = super.transform(value, pattern);
    return result;
  }

  map = {
    "Asia/Calcutta": "IST"
  };

}
